import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

function ScrollToTop() {
  const location = useLocation(); // Get the location object

  useEffect(() => {
    console.log(">>>", location.pathname);

    // Function to scroll to top with multiple fallbacks
    const scrollToTop = () => {
      // Method 1: Try window.scrollTo
      window.scrollTo(0, 0);

      // Method 2: Try document.documentElement.scrollTop
      if (document.documentElement) {
        document.documentElement.scrollTop = 0;
      }

      // Method 3: Try document.body.scrollTop (for older browsers)
      if (document.body) {
        document.body.scrollTop = 0;
      }
    };

    // Temporarily disable smooth scrolling
    const htmlElement = document.documentElement;
    const originalScrollBehavior = htmlElement.style.scrollBehavior;
    htmlElement.style.scrollBehavior = "auto";

    // Scroll immediately
    scrollToTop();

    // Also scroll after a small delay to ensure content is rendered
    setTimeout(() => {
      scrollToTop();
    }, 50);

    // Restore smooth scrolling after a delay
    setTimeout(() => {
      htmlElement.style.scrollBehavior = originalScrollBehavior || "smooth";
    }, 100);
  }, [location.pathname]); // Dependency array: re-run effect when pathname changes

  return null;
}

export default ScrollToTop;
